<template>
  <div class="list-latest-item-link">
    <sc-link v-if="fields && fields.link" :field="fields.link" />
  </div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Landing-Link',
  components: {
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.list-latest-item-link {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 3rem 2rem 3rem 2rem;

  @include tablet-up {
    width: calc(100% / 2 - 4rem);
    margin: 4rem 2rem 3rem 2rem;
  }

  a {
    @include font-styles('Arial Narrow', 3rem, 500, normal, 4rem, 0, $blue);
    text-transform: uppercase;
    position: relative;

    @include tablet-up {
      font-style: 3.7rem;
      line-height: 4.4rem;
    }

    &:after {
      content: '';
      display: inline-block;
      position: relative;
      background-image: url(~@/assets/images/icon-arrow-blue.svg);
      background-repeat: no-repeat;
      background-size: contain;
      margin-left: 1rem;
      width: 2.5rem;
      height: 1.5rem;
      transition: 0.25s;
      top: -0.25rem;
      left: 0;

      @include tablet-up {
        width: 3rem;
        height: 2rem;
      }
    }

    &:hover {
      &:after {
        left: 1rem;
      }
    }
  }
}
</style>
